/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const TokenType = Object.freeze({
  DEFAULT: 'DEFAULT',
  SHOP: 'SHOP',
  APIKEY: 'APIKEY',
  ACTION: 'ACTION',
});

export default TokenType;
